import * as React from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import Element from './Element';
import ConfigContext from '../config-provider/ConfigContext';
const SkeletonInput = function SkeletonInput(props) {
    const { prefixCls: customizePrefixCls, className, active } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const cls = classNames(prefixCls, className, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
    });
    return (React.createElement("div", { className: cls },
        React.createElement(Element, Object.assign({ prefixCls: `${prefixCls}-input` }, omit(props, ['prefixCls'])))));
};
SkeletonInput.displayName = 'SkeletonInput';
SkeletonInput.defaultProps = {
    size: 'default',
};
export default React.memo(SkeletonInput);
